import '../styles.scss'
import React from 'react'

// eslint-disable-next-line react/display-name
export default ({ emoji, count, user, handleEmojiClick }) => {
  return (
    <div className='emoji-reaction' data-user={user.id} data-emoji={emoji} onClick={handleEmojiClick}>
      <span className='emoji-icon' data-emoji={emoji} data-user={user.id}>
        {emoji === 'default_emoji' ? <i className='fa fa-smile-o fa-lg' data-emoji={emoji} /> : emoji}
      </span>
      <span className='emoji-count' data-emoji={emoji} data-user={user.id}>
        {count}
      </span>
    </div>
  )
}
